import { Box, Button, Image } from '@chakra-ui/react';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { FiCamera } from 'react-icons/fi';

import { compressPhoto } from './compressPhoto';

// botão que abre a câmera traseira do celular e mostra a prévia da foto
export function PhotoInput({
  label,
  value,
  onChange,
  onPreparing,
}: {
  label: string;
  value: Blob | null;
  onChange: (photo: Blob | null) => void;
  onPreparing?: (preparing: boolean) => void;
}) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState('');
  const [preparing, setPreparing] = useState(false);

  useEffect(() => {
    if (!value) {
      setPreview('');
      return undefined;
    }

    const url = URL.createObjectURL(value);

    setPreview(url);

    // solta a prévia anterior da memória
    return () => URL.revokeObjectURL(url);
  }, [value]);

  const handleFile = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    // limpa o campo para poder tirar a mesma foto de novo
    if (fileRef.current) {
      fileRef.current.value = '';
    }

    if (!file) {
      return;
    }

    setPreparing(true);
    onPreparing?.(true);
    onChange(await compressPhoto(file));
    setPreparing(false);
    onPreparing?.(false);
  };

  const open = () => fileRef.current?.click();

  return (
    <>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFile}
        style={{ display: 'none' }}
        aria-label={label}
      />
      {preview ? (
        <Box>
          <Image
            src={preview}
            alt={label}
            borderRadius="12px"
            w="100%"
            maxH="320px"
            objectFit="cover"
          />
          <Button
            mt="2"
            w="100%"
            variant="outline"
            leftIcon={<FiCamera />}
            onClick={open}
          >
            Tirar outra
          </Button>
        </Box>
      ) : (
        <Button
          w="100%"
          h="20"
          variant="outline"
          borderStyle="dashed"
          borderWidth="2px"
          leftIcon={<FiCamera size="24" />}
          isLoading={preparing}
          loadingText="Preparando a foto..."
          onClick={open}
        >
          {label}
        </Button>
      )}
    </>
  );
}
